/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';

import { Priority } from '@touchplan/common';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { FancyAction } from '../base/FancyAction';
import { FancyFirebaseList } from '../base/FancyFirebaseList';

export class PriorityList extends FancyFirebaseList<Priority, FancyAction> {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, FancyAction, fancyJoins);
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		return new Priority(action.payload.val(), action.key);
	}
	public $$updated(child: Priority, action: AngularFireAction<DatabaseSnapshot<any>>) {
		child.update(action.payload.val());
	}
}
